module.exports = __webpack_public_path__ + "img/powered-by-selgem.83a8da0e.png";